import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-crystall',
  templateUrl: './icon-crystall.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCrystallComponent {}
